<template>
  <div>
    <div class="flex" v-if="plans">
      <div class="ui">
        <button
          class="planButtons"
          v-for="(plan, id) in plans"
          :key="id"
          @click="currentPlan = id"
          :class="currentPlan === id ? 'active' : ''"
          :text="plan"
          transparent
          color="yellow"
        >
          {{ plan }}
        </button>
      </div>
      <div class="schedule">
        <Month
          month="Mar/Apr"
          startDate="2024-03-28"
          endDate="2024-04-30"
          :plan="plans[currentPlan]"
          :games="games"
          stopAfter="2024-04-30"
        />
        <Month
          showOnly="2024-05-01"
          month="May"
          startDate="2024-05-01"
          endDate="2024-05-31"
          :plan="plans[currentPlan]"
          :games="games"
        />
        <Month
          showOnly="2024-06-01"
          month="June"
          startDate="2024-06-01"
          endDate="2024-06-30"
          :plan="plans[currentPlan]"
          :games="games"
        />
        <Month
          showOnly="2024-07-01"
          month="July"
          startDate="2024-07-01"
          endDate="2024-07-31"
          :monthEndColumn="6"
          :plan="plans[currentPlan]"
          :games="games"
        />
        <Month
          showOnly="2024-08-01"
          month="August"
          startDate="2024-07-31"
          endDate="2024-08-31"
          rightAlign
          :plan="plans[currentPlan]"
          :games="games"
        />
        <Month
          stopAfter="2024-10-01"
          month="Sept/Oct"
          startDate="2024-09-01"
          endDate="2024-10-01"
          :plan="plans[currentPlan]"
          :games="games"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Month from "@/components/sections/Schedule/Month";
export default {
  name: "SeasonTicketPlans",
  components: {
    Month,
  },
  mounted() {
    console.log("plans", this.plans);
  },
  computed: {
    plans() {
      return this.$store.getters
        .getSubSectionsByParent("3")
        .map((s) => s.title);
    },
  },
  data() {
    return {
      currentPlan: 0,
      games: [
        {
          date: "March 28 2024",
          opponent: "TOR",
          plans: ["we", "fr", "wd", "st", "su"],
          time: "4:10 PM",
        },
        {
          date: "March 29 2024",
          opponent: "TOR",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "March 30 2024",
          opponent: "TOR",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "March 31 2024",
          opponent: "TOR",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "April 1 2024",
          opponent: "TEX",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "April 2 2024",
          opponent: "TEX",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "April 3 2024",
          opponent: "TEX",
          plans: ["wd", "su"],
          time: "1:10 PM",
        },
        {
          date: "April 12 2024",
          opponent: "SF",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "April 13 2024",
          opponent: "SF",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "April 14 2024",
          opponent: "SF",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "April 15 2024",
          opponent: "LAA",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "April 16 2024",
          opponent: "LAA",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "April 17 2024",
          opponent: "LAA",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "April 18 2024",
          opponent: "LAA",
          plans: ["wd", "su"],
          time: "1:10 PM",
        },
        {
          date: "April 22 2024",
          opponent: "DET",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "April 23 2024",
          opponent: "DET",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "April 24 2024",
          opponent: "DET",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "May 3 2024",
          opponent: "NYM",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "May 4 2024",
          opponent: "NYM",
          plans: ["we", "st"],
          time: "7:15 PM",
        },
        {
          date: "May 5 2024",
          opponent: "NYM",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "May 6 2024",
          opponent: "CWS",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "May 7 2024",
          opponent: "CWS",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "May 8 2024",
          opponent: "CWS",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "May 10 2024",
          opponent: "NYY",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "May 11 2024",
          opponent: "NYY",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "May 12 2024",
          opponent: "NYY",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "May 20 2024",
          opponent: "BOS",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "May 21 2024",
          opponent: "BOS",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "May 22 2024",
          opponent: "BOS",
          plans: ["wd", "su"],
          time: "6:50 PM",
        },
        {
          date: "May 24 2024",
          opponent: "KC",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "May 25 2024",
          opponent: "KC",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "May 26 2024",
          opponent: "KC",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "May 28 2024",
          opponent: "OAK",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "May 29 2024",
          opponent: "OAK",
          plans: ["wd", "su"],
          time: "6:50 PM",
        },
        {
          date: "May 30 2024",
          opponent: "OAK",
          plans: ["wd"],
          time: "1:10 PM",
        },
        {
          date: "June 7 2024",
          opponent: "BAL",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "June 8 2024",
          opponent: "BAL",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "June 9 2024",
          opponent: "BAL",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "June 10 2024",
          opponent: "BAL",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "June 11 2024",
          opponent: "CHC",
          plans: ["wd", "su"],
          time: "6:50 PM",
        },
        {
          date: "June 12 2024",
          opponent: "CHC",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "June 13 2024",
          opponent: "CHC",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "June 24 2024",
          opponent: "SEA",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "June 25 2024",
          opponent: "SEA",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "June 26 2024",
          opponent: "SEA",
          plans: ["wd"],
          time: "12:10 PM",
        },
        {
          date: "June 28 2024",
          opponent: "WSH",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "June 29 2024",
          opponent: "WSH",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "June 30 2024",
          opponent: "WSH",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "July 9 2024",
          opponent: "NYY",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "July 10 2024",
          opponent: "NYY",
          plans: ["wd", "su"],
          time: "6:50 PM",
        },
        {
          date: "July 11 2024",
          opponent: "NYY",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "July 12 2024",
          opponent: "CLE",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "July 13 2024",
          opponent: "CLE",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "July 14 2024",
          opponent: "CLE",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "July 26 2024",
          opponent: "CIN",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "July 27 2024",
          opponent: "CIN",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "July 28 2024",
          opponent: "CIN",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "July 30 2024",
          opponent: "MIA",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "July 31 2024",
          opponent: "MIA",
          plans: ["wd"],
          time: "12:10 PM",
        },
        {
          date: "August 9 2024",
          opponent: "BAL",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "August 10 2024",
          opponent: "BAL",
          plans: ["we", "st"],
          time: "7:15 PM",
        },
        {
          date: "August 11 2024",
          opponent: "BAL",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "August 12 2024",
          opponent: "HOU",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "August 13 2024",
          opponent: "HOU",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "August 14 2024",
          opponent: "HOU",
          plans: ["wd", "su"],
          time: "6:50 PM",
        },
        {
          date: "August 16 2024",
          opponent: "AZ",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "August 17 2024",
          opponent: "AZ",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "August 18 2024",
          opponent: "AZ",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "August 30 2024",
          opponent: "SD",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "August 31 2024",
          opponent: "SD",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "September 1 2024",
          opponent: "SD",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
        {
          date: "September 2 2024",
          opponent: "MIN",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "September 3 2024",
          opponent: "MIN",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "September 4 2024",
          opponent: "MIN",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "September 5 2024",
          opponent: "MIN",
          plans: ["wd", "su"],
          time: "1:10 PM",
        },
        {
          date: "September 17 2024",
          opponent: "BOS",
          plans: ["wd", "fr"],
          time: "6:50 PM",
        },
        {
          date: "September 18 2024",
          opponent: "BOS",
          plans: ["wd", "st"],
          time: "6:50 PM",
        },
        {
          date: "September 19 2024",
          opponent: "BOS",
          plans: ["wd"],
          time: "6:50 PM",
        },
        {
          date: "September 20 2024",
          opponent: "TOR",
          plans: ["we", "fr"],
          time: "6:50 PM",
        },
        {
          date: "September 21 2024",
          opponent: "TOR",
          plans: ["we", "st"],
          time: "4:10 PM",
        },
        {
          date: "September 22 2024",
          opponent: "TOR",
          plans: ["we", "su"],
          time: "1:40 PM",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: center;
  max-width: 1024px;
  margin: 0 auto;
  flex-wrap: wrap;
}
.flex > * {
  flex: 0 0 100%;
}
.ui {
  width: 100%;
  /* margin-bottom: 10px; */
  display: flex;
  /* flex-wrap: no-wrap; */
  /* justify-content: space-between; */
  margin: -1px;
  @media only screen and (max-width: $sm) {
    flex-direction: column;
  }
  .planButtons {
    flex: 1;
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    @media only screen and (max-width: $md) {
      font-size: 12px;
      line-height: 1;
      padding: 5px 3px;
      width: 100%;
    }
    line-height: 145%;
    text-align: center;
    text-transform: uppercase;
    color: #161e26;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    min-height: 30px;
    box-sizing: border-box;
    user-select: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #161e26;
    background: #b2b2b2;
    border: none;
    border-right: 1px solid #00285e;
    &:last-child {
      border-right: none;
    }
    vertical-align: middle;
    transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
    &:hover,
    &.active {
      background: $yellow;
    }
    /* @media (max-width: $md) {
      flex: 1 0 33.33%;
      border: 1px solid #525252;
    } */
  }
}
.schedule {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  /* gap: 5px; */
  width: 100%;
}
@media (min-width: 440px) {
  .ui {
    flex-grow: 0;
    flex-shrink: 0;
    width: 155px;
  }
  .schedule {
    /* margin-left: 5px; */
  }
  .flex {
    display: flex;
  }
}
@media (min-width: 720px) {
  .schedule {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1000px) {
  .schedule {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
